import { useNavigate } from 'react-router-dom';
import { Button } from '@carbon/react';

import styles from 'theme/features/errors/error-view.module.scss';

const ErrorView = ({ code, description }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <h1 className={styles['error-code']}>{code}</h1>
      <h2 className={styles.heading}>Oops &#8212; that&#8217;s not right!</h2>
      <p>{description}</p>
      <Button size="sm" className={styles.button} onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </div>
  );
};

export default ErrorView;
